// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateLaborRateChangesLength = (state, action) => action.length;

export default (state = getWipDefaultState().laborRateChangesLength, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_LABOR_RATE_CHANGES]: updateLaborRateChangesLength
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/labor-rate-changes-length.js